<script>
	export let href="";
  import Title from "./Title.svelte";
  function toggleFilter() {
    if (document.getElementById("filterCont").style.display == "none") {
      document.getElementById("filterCont").style.display = "block";
    } else if (document.getElementById("filterCont").style.display == "block") {
      document.getElementById("filterCont").style.display = "none";
    } else {
      document.getElementById("filterCont").style.display = "block";
    }
  }

</script>
<!-- 			
<style>
			
</style> -->
<aside
id="filterCont"
class="fixed inset-0 z-50 hidden w-full h-full mt-0 overflow-y-auto bg-white border-t shadow-lg lg:block lg:sticky md:fixed lg:rounded-lg lg:w-1/5 lg:px-3 lg:mx-3 md:mt-10 lg:mt-10 lg:z-0 overscroll-contain"
style="top: 90px;">
<div class="sticky-sidebar">
  <div class="sticky-sidebar-inner lg:pb-24 lg:mb-5 lg:mt-5">
    <div class="sticky top-0 z-10 py-1 bg-white shadow-md lg:py-0 lg:shadow-none">
    <div class="absolute top-0 right-0 block mt-4 mr-2 md:hidden">
      <button  aria-label="Toggle Filter"
        class="p-2 text-xl border border-gray-300 rounded-lg"
        on:click={toggleFilter}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          class="w-4 h-4">
          <path
            d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414
              1.414L10 11.414l7.071 7.071 1.414-1.414L11.414
              10l7.071-7.071-1.414-1.414L10 8.586z" />
        </svg>
      </button>
    </div>
            <Title subtitle="Navigasi Pengelola Toko" title="Menu" />
            </div>
            <form
              action=""
              class="products-filter"
              data-target="product-filter.form"
              method="get">
              <input id="filter_text" name="filter[text]" type="hidden" />
              <ul class="w-full mb-8 text-sm lg:block">
                
                <li class="chevron-right">
                  <a
                    class="block px-3 py-2 font-bold transition hover:bg-gray-100"
                    href="tokoku/produk">
                    Produk
                  </a>
                  <ul class="w-full mb-8 text-sm border-b border-gray-500 lg:block">
                
                    <li class="chevron-right hover:font-semibold">
                      <a
                        class="block px-3 py-2 transition hover:bg-gray-100"
                        href="tokoku/add">
                        - Tambah Produk
                      </a>
                    </li> 
                    <li class="chevron-right hover:font-semibold">
                      <a
                        class="block px-3 py-2 transition hover:bg-gray-100"
                          href="{href}">
                        - Daftar Produk
                      </a>
                    </li> 
                  </ul>
                </li> 
                <li class="chevron-right">
                  <a
                  class="block px-3 py-2 font-bold transition hover:bg-gray-100"
                  href="{href}">
                  Toko
                </a>
                <ul class="w-full mb-8 text-sm border-b border-gray-500 lg:block">
                  
            <li class="chevron-right hover:font-semibold">
              <a
              class="block px-3 py-2 transition hover:bg-gray-100"
              href="{href}">
              - Lihat Toko
            </a>
         </li> 
         <li class="chevron-right hover:font-semibold">
           <a
           class="block px-3 py-2 transition hover:bg-gray-100"
           href="tokoku/edit">
           - Perbaharui Toko
         </a>
      </li> 
                </ul>
                </li>
               
              </ul>
            </form>
          </div>
        </div>
      </aside>